import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { agentLinks, agentModuleEnabled } from './data/agent-module';

/**
 * Placeholder for the dedicated sales-agent role: until the backend ships a
 * `PermissionResource` for it, the settings decide. With the module off, or
 * the signed-in demo agent disabled, the app sends back to the PIM.
 */
export const agentGuard: CanActivateFn = () =>
  (agentModuleEnabled() && agentLinks()[0]?.isEnabled !== false) ||
  inject(Router).createUrlTree(['/']);
